import BlankEvent from '@components/blank/BlankEvent';
import InfinityScrollTrigger from '@components/InfinityScrollTrigger';

import { BoardCardList } from '../BoardCard';
import EventItem from './EventItem';
import BoardCardSkeletons from '../BoardCard/BoardCardSkeletons';
import useEvents from './hooks/useEvents';

function EventList() {
    const {
        events, fetchNextPage, isPending, isFetchingNextPage, isBlank,
    } = useEvents();
    return (
        <BoardCardList fullWidth as='main' spacing={4}
            align='center'>
            {isBlank && (
                <BlankEvent/>
            )}
            {events?.map((event) => (
                <EventItem key={event.id}
                    event={event} />
            ))}
            {(isPending || isFetchingNextPage) && (
                <BoardCardSkeletons withImage count={isPending ? 3 : 1} />
            )}
            <InfinityScrollTrigger trigger={fetchNextPage} />
        </BoardCardList>
    );
}

export default EventList;
